import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ChevronDown, HelpCircle } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FaqItem({
  question,
  answer,
  isOpen,
  onClick
}: FaqItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-109">
      <button onClick={onClick} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-110">
        <span className={`text-lg font-medium transition-colors ${isOpen ? 'text-[#BC6C25]' : 'text-gray-800 group-hover:text-[#BC6C25]'}`} data-id="element-111">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-[#BC6C25]' : ''}`} data-id="element-112" />
      </button>
      <AnimatePresence data-id="element-113">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-114">
            <p className="pb-6 text-gray-600 leading-relaxed" data-id="element-115">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Me sirve si estoy empezando y tengo miedo con la comida?',
    answer: 'Sí. Está diseñada para quitarte la duda diaria con pautas claras + recetas repetibles. Es ideal para principiantes que necesitan estructura.'
  }, {
    question: '¿Y si cocino para mi pareja/padre/madre con diabetes?',
    answer: 'Perfecta: te da estructura para no improvisar y tener ideas seguras para el día a día. Podrás cocinar platos que disfrute toda la familia.'
  }, {
    question: '¿Sustituye a un médico o nutricionista?',
    answer: 'No. Es una guía educativa y práctica para acompañar tu rutina. Consulta con un profesional para ajustes personalizados o medicación.'
  }];
  return <Section background="cream" className="pb-16 md:pb-24" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <div className="text-center mb-8 md:mb-12" data-id="element-118">
          <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#BC6C25]/10 text-[#BC6C25] mb-3" data-id="element-119">
            <HelpCircle className="w-5 h-5 md:w-6 md:h-6" data-id="element-120" />
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D6A4F]" data-id="element-121">
            Preguntas rápidas
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 md:p-8 mb-10 md:mb-16" data-id="element-122">
          {faqs.map((faq, index) => <FaqItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-123" />)}
        </div>

        {/* Final CTA */}
        <div id="compra" className="text-center bg-[#2D6A4F] rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-xl relative overflow-hidden" data-id="element-124">
          {/* Decorative circles */}
          <div className="absolute top-0 left-0 w-32 h-32 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-125"></div>
          <div className="absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-126"></div>

          <h3 className="text-xl md:text-3xl font-bold text-white mb-3 relative z-10" data-id="element-127">
            Si hoy mismo quieres pasar de la confusión a un plan sencillo, esta
            guía es un buen primer paso.
          </h3>

          <div className="flex flex-col items-center justify-center gap-1.5 mb-6 relative z-10" data-id="element-128">
            <span className="text-white/70 line-through text-lg" data-id="element-129">
              Antes 9,99 €
            </span>
            <span className="text-3xl md:text-4xl font-bold text-[#FEFAE0]" data-id="element-130">
              Ahora 6,39 €
            </span>
            <span className="text-[#FEFAE0]/80 text-sm font-medium bg-white/10 px-3 py-1 rounded-full" data-id="element-131">
              Oferta de lanzamiento
            </span>
          </div>

          <a href="https://cuidarte360.com/cart/55943901675846:1" target="_blank" rel="noopener noreferrer" className="inline-block relative z-10" data-id="element-132">
            <Button variant="primary" size="lg" className="w-full md:w-auto min-w-[280px] bg-[#BC6C25] hover:bg-[#A45D1E] text-white border-none shadow-xl" data-id="element-133">
              Descargar ahora por 6,39 €
            </Button>
          </a>

          <p className="text-white/60 text-xs mt-4 relative z-10" data-id="element-134">
            Descarga digital inmediata. No incluye garantía ni devolución.
          </p>
        </div>
      </div>
    </Section>;
}